<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>歷史車輛分佈</h3>
          <hr />
        </div>
      </div>
      <div class="x_panel">
        <div class="row">
          <div id="map" ref="map" class="col-md-8 col-sm-8 mapblocklarge">
            map
          </div>
          <div class="col-md-4">
            <div class="x_panel">
              <div class="x_content">
                <div class="row">
                  <div class="col-md-12">
                    <h4 class="black-word fontSize20">選擇時間:</h4>
                    <DateSelect ref="startTime"></DateSelect>
                    <button
                      type="button"
                      class="mybtnstyle btn-success"
                      @click="_getDriverLocations"
                    >
                      搜尋時間
                    </button>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="black-word fontSize20">選擇呼號/隊編位置</h4>
                    <select
                      id="heard"
                      class="form-control fontSize16"
                      v-model="driver_account"
                      @change="onCallNumberOptionChange(driver_account)"
                      required=""
                    >
                      <option value="">呼號/隊編 - 姓名</option>
                      <option
                        v-for="driver in driver_options"
                        v-bind:value="driver.phone"
                      >
                        {{ driver.call_number }} - {{ driver.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row" style="margin-top: 10px">
                  <div class="col-md-12">
                    <input
                      type="number"
                      required="required"
                      class="inputstyle col-md-3 fontSize16"
                      placeholder="輸入呼號"
                      v-model="callNumber"
                    />
                    <button
                      type="button"
                      class="mybtnstyle btn-success"
                      @click="onSearchCallNumber"
                    >
                      搜尋
                    </button>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-md-12">
                    <AddrAutoComplete
                      class="col-md-12"
                      v-model="inputAddr"
                      @getSelectedAddr="getSelectedAddr"
                    />
                    <button
                      type="button"
                      class="mybtnstyle btn-success"
                      @click="setLocationMarker"
                    >
                      地址搜尋
                    </button>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-md-6">
                    <button
                      type="button"
                      class="mybtnstyle btn-primary"
                      @click="onDownloadKml"
                    >
                      重新下載派遣排班區
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="x_panel">
              <div class="x_content">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-4 textareastyle fontSize20">
                      <h4 class="blockinline black-word">總車輛:</h4>
                      <h3 class="blockinline red_textcolor">{{ total }}</h3>
                    </div>
                    <div class="col-md-8">
                      <button
                        type="button"
                        :class="{ 'btn-danger': !sortBy, 'btn-dark': sortBy }"
                        @click="onFilterConditionClick(false)"
                        class="btn fontSize20"
                      >
                        全部車輛
                      </button>
                      <button
                        type="button"
                        :class="{ 'btn-danger': sortBy, 'btn-dark': !sortBy }"
                        @click="onFilterConditionClick(true)"
                        class="btn fontSize20"
                      >
                        上線車輛
                      </button>
                    </div>
                  </div>
                  <div class="row textareastyle">
                    <div class="col-md-6">
                      <a class="black-word fontSize20">
                        <img
                          src="../../../src/assets/images/driver-status/taxi.png"
                        />
                        空車
                      </a>
                      <h5 class="blockinline fontSize20 red_textcolor">
                        {{ vacant }}
                      </h5>
                    </div>
                    <div class="col-md-6">
                      <a class="black-word fontSize20">
                        <img
                          src="../../../src/assets/images/driver-status/take_passenger.png"
                        />
                        載客中
                      </a>
                      <h5 class="blockinline fontSize20 red_textcolor">
                        {{ hired }}
                      </h5>
                    </div>
                  </div>
                  <div class="row textareastyle">
                    <div class="col-md-6">
                      <a class="black-word fontSize20">
                        <img
                          src="../../../src/assets/images/driver-status/hailing.png"
                        />
                        派遣中
                      </a>
                      <h5 class="blockinline fontSize20 red_textcolor">
                        {{ dispatched }}
                      </h5>
                    </div>
                    <div class="col-md-6">
                      <a class="fontSize20 black-word">
                        <img
                          src="../../../src/assets/images/driver-status/shift.png"
                        />
                        排班車
                      </a>
                      <h5 class="blockinline fontSize20 red_textcolor">
                        {{ shift }}
                      </h5>
                    </div>
                  </div>
                  <div class="row textareastyle">
                    <div class="col-md-6">
                      <a class="fontSize20 black-word">
                        <i class="fa fa-ban fa-1x"></i>
                        停權
                      </a>
                      <h5 class="blockinline fontSize20 red_textcolor">
                        {{ suspension }}
                      </h5>
                    </div>
                    <div class="col-md-6">
                      <a class="fontSize20 black-word">
                        <img
                          src="../../../src/assets/images/driver-status/rest.png"
                        />
                        休息中
                      </a>
                      <h5 class="blockinline fontSize20 red_textcolor">
                        {{ rest }}
                      </h5>
                    </div>
                  </div>
                  <div class="row textareastyle">
                    <div class="col-md-6">
                      <a class="fontSize20 black-word">
                        <img
                          src="../../../src/assets/images/driver-status/interrupt.png"
                        />
                        失聯
                      </a>
                      <h5 class="blockinline fontSize20 red_textcolor">
                        {{ disappearance }}
                      </h5>
                    </div>
                    <div class="col-md-6">
                      <a class="fontSize20 black-word">
                        <img
                          src="../../../src/assets/images/driver-status/logout.png"
                        />
                        登出
                      </a>
                      <h5 class="blockinline fontSize20 red_textcolor">
                        {{ logout }}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="x_panel">
              <div class="x_content">
                <driver-monitor-tab
                  ref="monitorTab"
                  :driverInfo="driver_info"
                  :shiftAreaInfo="shift_area_info"
                  :dispatchAreaInfo="dispatch_area_info"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { cookies } from '@/utils/cookies'
import { ApiKey } from '@/assets/js/libs/GoogleAPI'
import GoogleMapsLoader from 'google-maps'
import API from '@/assets/js/libs/API'
import Driver from '@/assets/js/libs/Driver'
import AutoComplete from '../mapComponent/AutoComplete.vue'
import AddrAutoComplete from '@/components/tool/AddrAutoComplete'
import DateSelect from '@/components/tool/DateSelect'
import DriverMonitorTab from '@/components/driver/DriverMonitorTab'
import kmlTool from '@/assets/js/tool/kmlTool.js'
import checkStateAndDirection from '@/assets/js/tool/checkCarDirection'

const driver = new Driver()
const crossMarker = require('../../assets/images/crosshair.png')

export default {
  name: 'DriverMonitor',
  components: {
    AutoComplete,
    AddrAutoComplete,
    DateSelect,
    DriverMonitorTab,
  },
  data() {
    return {
      fullPage: false,
      loader: null,
      driver_options: [],
      driver_account: '',
      driver_markers: [],
      addressDetail: [],
      addresses: [],
      driver_info: {
        address: '',
        call_number: '',
        licence: '',
        status: null,
        car_year: null,
        name: '',
        gender: null,
        car_brand: '',
        account: '',
        note: '',
        service_list: '',
        updated_at: null,
        exclusive_service: null,
      },
      shift_area_info: {
        name: '',
        area_capacity: null,
        specific_group: '',
        in_line_time1_start: null,
        in_line_time2_start: null,
        in_line_time1_end: null,
        in_line_time2_end: null,
        note: '',
      },
      dispatch_area_info: {},
      shift_areas: [],
      dispatch_areas: [],
      driver_locations: [],
      temp_center: {},
      refreshFunc: null,
      // time:15000,
      sortBy: true, // 顯示上線車輛(空車、派遣、載客)
      callNumber: null,
      // teamlist:[],
      mainTeamCode: '',
      locationMarker: null,
      inputAddr: '',
      autoLocation: {
        longitude: null,
        latitude: null,
      },
      kmlParser: null,
    }
  },
  methods: {
    onDownloadKml() {
      kmlTool.clearKml()
      kmlTool.getDispatchCode()
      kmlTool.getSchualedCode()
    },
    getSelectedAddr({ longitude, latitude }) {
      this.autoLocation = {
        longitude: longitude,
        latitude: latitude,
      }
    },
    setLocationMarker() {
      if (this.locationMarker !== null) {
        this.locationMarker.setMap(null)
        this.locationMarker = null
      }
      this.locationMarker = new google.maps.Marker({
        position: {
          lat: this.autoLocation.latitude,
          lng: this.autoLocation.longitude,
        },
        map: this.map,
        icon: crossMarker,
      })

      this.map.setCenter({
        lng: this.autoLocation.longitude,
        lat: this.autoLocation.latitude,
      })

      this.map.setZoom(this.map.getZoom())
    },
    showLoading() {
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      })
    },
    _getDriverLocations() {
      this.showLoading()
      let startTime = this.$refs.startTime.getDate()
      API.get(`/driver/histroy/allLocation?startTime=${startTime}`)
        .then((res) => {
          this._setMarkerClear()
          this.driver_locations = res.result
          this.setDriverMarkers(res.result)
          this.moveMapCenter()
          this.loader.hide()
        })
        .catch((err) => {
          this.$msg(err)
          this.loader.hide()
        })
    },
    moveMapCenter() {
      setTimeout(() => {
        if (this.temp_center.hasOwnProperty('lat')) {
          this.map.setCenter({
            lat: this.temp_center.lat,
            lng: this.temp_center.lng,
          })
          this.map.setZoom(this.temp_center.zoom)
        }
      }, 300)
    },
    refreshDriverLocationByTimeInterval() {
      this._setMarkerClear()
      if (!location.hash.includes('DriverMonitor')) {
        // clearInterval(this.refreshFunc)
      }
    },
    _setMarkerClear() {
      this.driver_markers.forEach((markers) => {
        markers.setMap(null)
      })
      this.driver_markers = []
    },
    setDriverMarkers(data) {
      data.forEach((driver_info) => {
        // console.log(driver_info);
        console.log(
          checkStateAndDirection.checkCarDirectionOutputImage(
            driver_info.degrees,
            driver_info.status,
          ),
        )
        let numberMarkerImg = {
          url: checkStateAndDirection.checkCarDirectionOutputImage(
            driver_info.degrees,
            driver_info.status,
          ).img,
          labelOrigin: new google.maps.Point(10, 30),
        }
        let marker
        marker = new google.maps.Marker({
          position: {
            lat: driver_info.lat,
            lng: driver_info.lng,
          },
          label: String(driver_info.callNumber),
          map: this.map,
          labelAnchor: new google.maps.Point(25, 0),
          icon: numberMarkerImg,
        })
        marker.data = driver_info
        var self = this
        /* 按了marker會顯示跳到司機tab，顯示司機資訊 */
        marker.addListener('click', () => {
          $('#home-tab').click()
          // console.log('this.data', driver_info)
          driver
            .getInfo(driver_info.account, driver_info.teamCode)
            .then((res) => {
              self.driver_info = res.info
              self.driver_info.status = driver.getFormatStatus(
                driver_info.status,
              ).name
              self.driver_info.gender = res.info.gender == 0 ? '男' : '女'
              self.driver_info.updated_at = moment(
                driver_info.updated_at,
              ).format('YYYY-MM-DD HH:mm:ss')
              self.driver_info.lat = driver_info.lat
              self.driver_info.lng = driver_info.lng
              this.$refs.monitorTab._clickItemToSetAddress(driver_info)
            })
            .catch((e) => {
              console.log(e)
            })
        })
        this.driver_markers.push(marker)
      })
      this.followSpecificDriver()
      if (this.driver_markers.length != 0 && this.driver_account == '') {
        // console.log('',this.driver_account);
        // this.map.setCenter({
        //   lng:this.driver_markers[0].data.lng,
        //   lat:this.driver_markers[0].data.lat
        // })
      }
    },
    onCallNumberOptionChange(account) {
      this.temp_center = {}
      this.followSpecificDriver()
      // 找尋司機資料
      driver
        .getInfo(account)
        .then((res) => {
          // console.log(res.info.status)
          this.driver_info = res.info
          this.driver_info.status = driver.getFormatStatus(res.info.status).name
          this.driver_info.gender = res.info.gender === 0 ? '男' : '女'
          this.driver_info.updated_at = moment(res.info.updated_at).format(
            'YYYY-MM-DD HH:mm:ss',
          )
          let driver_info = {
            lat: this.temp_center.lat,
            lng: this.temp_center.lng,
          }
          this.$refs.monitorTab._clickItemToSetAddress(driver_info)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    followSpecificDriver() {
      if (this.driver_account != '') {
        this.driver_markers.forEach((marker) => {
          if (marker.data.account == this.driver_account) {
            this.temp_center = {
              lat: marker.data.lat,
              lng: marker.data.lng,
              zoom: 16,
            }
          }
        })
        this.map.setCenter({
          lng: this.temp_center.lng,
          lat: this.temp_center.lat,
        })

        this.map.setZoom(16)
      }
    },
    _initMap() {
      var lat = parseFloat(cookies.get('GladAddressGps').coordinates[1])
      var lng = parseFloat(cookies.get('GladAddressGps').coordinates[0])
      this.map = undefined
      this.map = new google.maps.Map(this.$refs.map, {
        center: new google.maps.LatLng(lat, lng),
        gestureHandling: 'greedy',
        zoom: 14,
        mapTypeId: 'roadmap',
        streetViewControl: false,
      })
      let infowindow = new google.maps.InfoWindow({})
      this.kmlParser = new geoXML3.parser({
        map: this.map,
        infowindow: infowindow,
        singleInfoWindow: true,
        zoom: false,
        afterParse: (doc) => {
          try {
            // 確保 doc 和 placemarks 存在
            if (!doc || !doc[0] || !doc[0].placemarks) {
              console.warn('KML 解析結果中沒有 placemarks')
              return
            }

            const placemarks = doc[0].placemarks
            for (var i = 0; i < placemarks.length; i++) {
              var p = placemarks[i]

              // 確保 polygon 和 name 存在
              if (!p || !p.polygon || !p.name) {
                continue
              }

              try {
                // 確保 polygon 物件有效且已附加到地圖
                // 延遲添加事件監聽器，確保 polygon 完全初始化
                setTimeout(() => {
                  try {
                    if (p.polygon && typeof p.polygon.setMap === 'function') {
                      // 檢查 polygon 是否已設置到地圖上
                      if (p.polygon.getMap && p.polygon.getMap() === this.map) {
                        google.maps.event.addListener(
                          p.polygon,
                          'click',
                          () => {
                            this.searchDispatch(p.name)
                          },
                        )
                      } else {
                        // 如果還沒設置到地圖，先設置再添加監聽器
                        p.polygon.setMap(this.map)
                        google.maps.event.addListener(
                          p.polygon,
                          'click',
                          () => {
                            this.searchDispatch(p.name)
                          },
                        )
                      }
                    }
                  } catch (e) {
                    console.error('添加 polygon 事件監聽器時發生錯誤:', e, p)
                  }
                }, 50 * i) // 每個 polygon 延遲 50ms，避免同時初始化造成問題
              } catch (e) {
                console.error('處理 polygon 時發生錯誤:', e, p)
              }
            }
          } catch (e) {
            console.error('處理 KML placemarks 時發生錯誤:', e)
          }
        },
      })
      kmlTool.showDispatchKml(this.kmlParser)
      kmlTool.showSchualedKml(this.kmlParser)
    },
    searchDispatch(name) {
      // console.log(name)
      API.get(`dispatch-area/info/?name=${name}&search=name`)
        .then((res) => {
          // console.log(res)
          if (res.success) {
            $('#dispatch-tab').click()
            //area_capacity dispatch_strategy in_line_name1 in_line_name2 note
            this.dispatch_area_info = {
              name: res.result.name,
              area_capacity: res.result.area_capacity,
              dispatch_strategy: res.result.dispatch_strategy,
              in_line_name1: res.result.scheduledName[0],
              note: res.result.note,
            }
            if (
              res.result.scheduledName.length !== 1 &&
              res.result.scheduledName.length !== 0
            ) {
              this.dispatch_area_info.in_line_name2 =
                res.result.scheduledName[1]
            }
            return
          }
          this.searchSchedule(name)
        })
        .catch((err) => {
          // this.loader.hide()
          console.log('intersectionInfo', err)
        })
    },
    searchSchedule(name) {
      API.get(`/shift-area/info/?name=${name}&search=name`)
        .then((res) => {
          // console.log(res)
          if (res.success) {
            //name area_capacity in_line_time1_start in_line_time1_end in_line_time2_start in_line_time2_end note
            $('#shift-tab').click()
            this.shift_area_info = {
              name: res.result.name,
              area_capacity: res.result.area_capacity,
              in_line_time1_start: res.result.in_line_time1_start,
              in_line_time1_end: res.result.in_line_time1_end,
              in_line_time2_start: res.result.in_line_time2_start,
              in_line_time2_end: res.result.in_line_time2_end,
              note: res.result.note,
            }
          }
        })
        .catch((err) => {
          // this.loader.hide()
          console.log('intersectionInfo', err)
        })
    },
    onFilterConditionClick(status) {
      /* 顯示的車輛 */
      this.sortBy = status
      this.setDriverMarkers(this.driver_locations)
    },
    countCar(driver_locations, status) {
      return driver_locations.filter((driver) => {
        return driver.status == status
      }).length
    },
    onFilterLongTimeIsNotOnLine(data) {
      // 過濾api司機狀態資料，超過一分鐘未更新將提報為失聯
      var driverTimeOut = data.filter((driver_info) => {
        // console.log(driver_info.callNumber)
        // console.log(driver_info)
        var updatedTime = moment(driver_info.updated_at).format(
          'YYYY-MM-DD HH:mm:ss',
        )
        let outTime = !moment(updatedTime).isBetween(
          moment()
            .startOf('second')
            .subtract(5, 'm')
            .format('YYYY-MM-DD HH:mm:ss'),
          moment()
            .startOf('second')
            .subtract(-1, 'm')
            .format('YYYY-MM-DD HH:mm:ss'),
        )
        return outTime
      })
      for (let i = 0; i < driverTimeOut.length; i++) {
        driverTimeOut[i].status = 6
      }
    },
    onSearchCallNumber() {
      // alert('未開放')
      var count = 0
      if (this.callNumber === null) {
        alert('輸入呼號')
        return
      }
      for (let i = 0; i < this.driver_options.length; i++) {
        if (this.driver_options[i].call_number === this.callNumber) {
          this.driver_account = this.driver_options[i].phone
          this.onCallNumberOptionChange(this.driver_account)
        } else {
          count += 1
        }
      }
      if (count === this.driver_options.length) {
        alert('查無此司機')
      }
    },
    onClearCallNumber() {
      this.driver_account = ''
      this.callNumber = ''
      this.onCallNumberOptionChange()
    },
    _getlist(teamcode) {
      API.get(`driver/list/?code=${teamcode}&task=all`)
        .then((res) => {
          this.driver_options = res.driverList.sort((a, b) => {
            return a.call_number - b.call_number
          })
        })
        .catch((err) => {
          console.log('searchCustomerInfo', err)
        })
    },
  },
  computed: {
    vacant() {
      return this.countCar(this.driver_locations, 1)
    },
    hired() {
      return this.countCar(this.driver_locations, 3)
    },
    dispatched() {
      return this.countCar(this.driver_locations, 2)
    },
    shift() {
      return this.countCar(this.driver_locations, 4)
    },
    suspension() {
      return this.countCar(this.driver_locations, 7)
    },
    logout() {
      return this.countCar(this.driver_locations, 5)
    },
    disappearance() {
      return this.countCar(this.driver_locations, 6)
    },
    rest() {
      return this.countCar(this.driver_locations, 0)
    },
    total() {
      return this.driver_locations.length
    },
  },
  mounted() {
    const interval = setInterval(() => {
      if (this.$refs.map) {
        this.inputAddr = cookies.get('GladArea')
        const MainTeamCode = cookies.get('GladTeamCode')
        kmlTool.getDispatchCode()
        kmlTool.getSchualedCode()
        GoogleMapsLoader.KEY = ApiKey()
        GoogleMapsLoader.LIBRARIES = ['geometry', 'places']
        GoogleMapsLoader.load(() => {
          this._initMap()
        })
        this._getlist(MainTeamCode)
        clearInterval(interval)
      }
    }, 100)
  },
}
</script>

<style scoped>
input.inputstyle {
  min-width: 240px;
}

.black-word {
  color: #101010;
}
</style>



// WEBPACK FOOTER //
// src/pages/driver/DriverDistribution.vue